export default "__VITE_ASSET__Bxk6YZWO__"